export default [{
  text: '',
  items: [
    { icon: 'mdi-view-dashboard-outline', key: 'menu.dashboard', text: 'Dashboard', link: '/dashboard'  },
    { icon: 'mdi-license', key: 'menu.blank', text: 'Initialize Licenses', link: '/initializeLicenses' },
    { icon: 'mdi-cloud-print', key: 'menu.blank', text: 'Printable', link: '/printable' },
    { icon: 'mdi-tray-full', key: 'menu.blank', text: 'Printed Licenses', link: '/printedLicenses' },
    //{ icon: 'mdi-bell', key: 'menu.blank', text: 'Renewal', link: '/notification' } ,
    { icon: 'mdi-logout', key: 'menu.blank', text: 'Logout', link: '/logout' } 
  ]
}]